import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { BaseColumnSelectComponent } from '../base-column-selection.component';
import { DataService } from 'src/app/shared/network/data.service';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { ProjectService } from 'src/app/shared/project/project.service';
import { ImportProgressService } from 'src/app/shared/import/import-progress.service';
import { ImportStep } from 'src/app/shared/import/import-step';

@Component({
  templateUrl: './identities-selection.component.html',
  styleUrls: ['../../general.scss', '../column-selection.scss']
})
export class IdentitiesSelectComponent extends BaseColumnSelectComponent implements OnInit {
    projectId: string;
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;

    loading = false;
    dataLoaded = false;

    identityGroupColor: string[] = ['#01b0f1', '#66ffd1', '#ad1400', '#0045ad', '#28ad00', '#00aaad', '#ad0084', '#7000ad', '#adaa00', '#ad4e00' ];

    constructor(private dataService: DataService, private activatedRoute: ActivatedRoute, private router: Router,
        private projectService: ProjectService, private importProgressService: ImportProgressService) {
        super();
    }

    ngOnInit(): void {
        this.activatedRoute.queryParams.subscribe((queryParams: any) => {
            let projectId = queryParams.projectId;
            if(projectId) {
                this.projectId = projectId;
                this.projectService.setProjectId(projectId);
                this.dataService.get<ColumnForSelection[]>('columnSelection/identities/' + projectId)
                    .then(resp => {
                        if(resp && resp.length){
                            this.columns = resp;
                        } else {
                            this.router.navigateByUrl('/select-columns-redundant?projectId=' + this.projectId);
                        }
                        this.dataLoaded = true;
                    });
            }
        });
    }

    async save() {
        if (this.loading) {
            return;
        }
        try {
            this.loading = true;
            let req = [];
            for (var i = 0; i < this.columns.length; ++i) {
                if(this.columns[i].group != null && this.columns[i].isSelected) {
                    req.push({ group: this.columns[i].group, column: i });
                }
            }
            await this.dataService.post('columnSelection/identities', {
                projectId: this.projectId,
                identities: req,
            });
            this.importProgressService.setImportStep(ImportStep.dimensions);
            this.router.navigateByUrl('/select-columns-redundant?projectId=' + this.projectId);
        } finally {
            this.loading = false;
        }
    }
    
}
